export default [
    { iconClass: 'mdi-skype', propName: 'skype' },
    { iconClass: 'mdi-email', propName: 'email' },
    { iconClass: 'mdi-rocket', propName: 'rocketChat' }
];



// WEBPACK FOOTER //
// ./src/constants/socials.js